interface FlashcardHeaderProps {
  children: React.ReactNode
}

export default function FlashcardHeader({ children }: FlashcardHeaderProps) {
  return <div className="flex h-fit w-full">{children}</div>
}
